/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";
import "./style.css";

export const PropertySol = ({ className, imageClassName }) => {
  return (
    <div className={`property-SOL ${className}`}>
      <img className={`img ${imageClassName}`} alt="Image" src="/img/image-2.png" />
    </div>
  );
};
